module.exports = __webpack_public_path__ + "static/media/masterplan-1.b736b206.mp4";